export default __webpack_public_path__ + "static/media/rocket_anim_134.5b06a93a.png";